export interface ColumnConfig {
  id: string;
  name: string;
  type?: 'default' | 'custom';
  field?: string;
  visible?: boolean;
}

export const DEFAULT_COLUMNS: ColumnConfig[] = [
  { id: 'default-name', name: 'Name', type: 'default', field: 'lead_name', visible: true },
  { id: 'default-company', name: 'Company', type: 'default', field: 'company', visible: true },
  { id: 'default-phone', name: 'Phone', type: 'default', field: 'phone', visible: true },
  { id: 'default-email', name: 'Email', type: 'default', field: 'email', visible: true },
  { id: 'default-status', name: 'Status', type: 'default', field: 'status', visible: true },
  { id: 'default-priority', name: 'Priority', type: 'default', field: 'priority', visible: true },
  { id: 'default-products', name: 'Products', type: 'default', field: 'products', visible: true },
];

export function ensureDefaults(config: ColumnConfig[]): ColumnConfig[] {
  const hasDefaults = config.some(c => c.type === 'default');
  if (!hasDefaults) {
    // Migrate: prepend defaults, mark existing as custom
    return [
      ...DEFAULT_COLUMNS,
      ...config.map(c => ({ ...c, type: 'custom' as const, visible: c.visible ?? true })),
    ];
  }
  // Ensure any new default columns are added (e.g. products added after initial migration)
  const missingDefaults = DEFAULT_COLUMNS.filter(
    dc => !config.some(c => c.id === dc.id)
  );
  if (missingDefaults.length > 0) {
    return [...config, ...missingDefaults];
  }
  return config;
}
